<template>
  <UiDatePicker :end-year="endYear" v-bind="$attrs" v-on="$listeners" />
</template>
<script>
import UiDatePicker from '@@/layout/UiDatePicker';
export default {
  name: 'UiDatePickerEndFuture',
  components: {
    UiDatePicker,
  },
  props: {
    futureYears: {
      default: 3,
      type: Number,
    },
  },
  computed: {
    endYear() {
      return new Date().getFullYear() + this.futureYears;
    },
  },
};
</script>
